import React from 'react';
import { EXTRAS_COST } from '../../calculations/plomberieCalculations.js';
import RefinePanel from './RefinePanel.js';

const PLOMBERIE_OPTIONS = [
  { val: 'basique', label: 'Basique', desc: "Raccordement gouttière + robinet de soutirage", price: '~200 €' },
  { val: 'jardin', label: 'Réseau jardin', desc: "Alimentation point d'eau ext., tuyauterie enterrée", price: '~500 €' },
  { val: 'interieur', label: 'Intégration intérieure', desc: 'WC, lave-linge, réseau double-distribution', price: '~1 500 – 3 000 €' },
];

const POSE_OPTIONS = [
  { val: 'apparent', label: 'Apparent', desc: 'Tuyauterie visible, pose simple' },
  { val: 'encastre', label: 'Encastré', desc: 'Saignées + rebouchage, finition soignée' },
];

/** Section Plomberie & installation : 3 sous-blocs — arrivée d'eau, départ de l'eau, accessoires. */
const PlomberieSection = ({ plomberie, setPlomberie }) => (
  <div>
    <div className="rw-sub-label" style={{ marginTop: 0 }}>1. Arrivée d'eau</div>
    <p className="apv2-sim-hint">Raccordement de la ou des descentes de gouttière jusqu'à la cuve.</p>
    <div className="rw-param-row">
      <div className="rw-param-field">
        <label>Nombre de descentes à raccorder</label>
        <input
          type="number" min="1" step="1"
          value={plomberie.nbDescentes}
          onChange={e => setPlomberie({ nbDescentes: Math.max(1, +e.target.value || 1) })}
        />
      </div>
    </div>

    <div className="rw-sub-label">2. Départ de l'eau</div>
    <div className="rw-budget-grid rw-budget-grid--3">
      {PLOMBERIE_OPTIONS.map(opt => (
        <div
          key={opt.val}
          className={`rw-budget-card ${plomberie.plomberie === opt.val ? 'rw-budget-card--selected' : ''}`}
          onClick={() => setPlomberie({ plomberie: opt.val })}
        >
          <div className="rw-budget-card-label">{opt.label}</div>
          <div className="rw-budget-card-desc">{opt.desc}</div>
          <div className="rw-budget-card-price">{opt.price}</div>
        </div>
      ))}
    </div>

    <RefinePanel open={plomberie.refined} onToggle={() => setPlomberie({ refined: !plomberie.refined })}>
      <div className="apv2-filter-panel-row" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 14 }}>
        <div className="rw-param-field">
          <label>Distance canalisation enterrée (gouttière → cuve, ml)</label>
          <input
            type="number" min="0" step="1"
            value={plomberie.distanceCanalisation || 0}
            onChange={e => setPlomberie({ distanceCanalisation: +e.target.value || 0 })}
          />
        </div>

        {plomberie.plomberie === 'interieur' && (
          <>
            <div>
              <span className="apv2-filter-panel-label" style={{ display: 'block', marginBottom: 8 }}>Type de pose</span>
              <div className="rw-budget-grid rw-budget-grid--2">
                {POSE_OPTIONS.map(opt => (
                  <div
                    key={opt.val}
                    className={`rw-budget-card ${plomberie.poseType === opt.val ? 'rw-budget-card--selected' : ''}`}
                    onClick={() => setPlomberie({ poseType: opt.val })}
                  >
                    <div className="rw-budget-card-label">{opt.label}</div>
                    <div className="rw-budget-card-desc">{opt.desc}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="rw-param-field">
              <label>Nombre de points d'eau raccordés</label>
              <input
                type="number" min="1" step="1"
                value={plomberie.nbPointsEau}
                onChange={e => setPlomberie({ nbPointsEau: Math.max(1, +e.target.value || 1) })}
              />
            </div>
          </>
        )}
      </div>
    </RefinePanel>

    <div className="rw-sub-label">3. Accessoires</div>
    <div className="rw-budget-grid rw-budget-grid--2">
      {Object.entries(EXTRAS_COST).map(([key, cost]) => (
        <label key={key} className="rw-checkbox-opt">
          <input type="checkbox" checked={!!plomberie[key]} onChange={e => setPlomberie({ [key]: e.target.checked })} />
          <div>
            <div className="rw-budget-card-label">{cost.label}</div>
            <div className="rw-budget-card-price">{cost.low} – {cost.high} €</div>
          </div>
        </label>
      ))}
    </div>
  </div>
);

export default PlomberieSection;
